import { createFileRoute, redirect } from '@tanstack/react-router'
import { authClient } from '@/lib/auth-client'
import { queryClient } from '@/lib/query-client'

// Link target for other internal tools: <a href="https://admin.edclub.tech/logout">Sign out</a>
export const Route = createFileRoute('/logout')({
	beforeLoad: async ({ preload }) => {
		// Hovering a <Link to="/logout"> preloads this route (defaultPreload: 'intent'); only sign out on a real visit.
		if (preload) return
		await authClient.signOut()
		queryClient.clear()
		throw redirect({ to: '/login', replace: true })
	}
})
